import { useQuery } from "@apollo/client";
import { graphql } from "gql/apollo";
import { StreamType } from "gql/apollo/graphql";
import { useMemo } from "react";
import { resolveStreamFragmentData } from "../resolveStreamFragmentData";

export const ListStreams = graphql(/* GraphQL */ `
	query listStreamsApollo($params: ListStreamsParams!) {
		newListStreams(params: $params) {
			__typename
			_id
			gid
			name
			share_type
			is_owner
			transferred_date
			type
			criterion_updated
			owner {
				gid
				name
			}
			... on StandardStream {
				...standardStreamFields
			}
			... on IncidentStream {
				...incidentStreamFields
			}
			... on WebAlertsStream {
				...webAlertsStreamFields
			}
			... on DarkWebStream {
				...darkWebStreamFields
			}
		}
	}
`);

interface Props {
	streamIds?: string[];
	skip?: boolean;
}
export const useListStreams = ({ streamIds, skip = false }: Props) => {
	const { data, loading, error } = useQuery(ListStreams, {
		variables: {
			params: {
				_ids: streamIds,
				types: [
					StreamType.STANDARD,
					StreamType.WEB_ALERTS,
					StreamType.DARK_WEB,
					StreamType.INCIDENT,
				],
			},
		},
		skip,
	});

	const resolvedStreamsData = useMemo(
		() => data?.newListStreams.map(resolveStreamFragmentData),
		[data?.newListStreams]
	);

	return {
		streams: resolvedStreamsData,
		loading,
		error,
	};
};

export type Stream = NonNullable<
	ReturnType<typeof useListStreams>["streams"]
>[number];

export type StandardStream = Extract<Stream, { __typename: "StandardStream" }>;
export type IncidentStream = Extract<Stream, { __typename: "IncidentStream" }>;
export type WebAlertsStream = Extract<
	Stream,
	{ __typename: "WebAlertsStream" }
>;
export type DarkWebStream = Extract<Stream, { __typename: "DarkWebStream" }>;
